import ActionTypes from "./ActionTypes";
import InteractionTypes from "./InteractionTypes";

const FeatureType = 'Accelerated Reader';

const AcceleratedReaderEventTypes = {
    ACCELERATEDREADER_SEARCH_CLICKED: {
        featureClick: {
            name: "AcceleratedReaderSearch"
        },
        interaction: {
            name: 'Accelerated Reader: Search - clicked',
            actionType: ActionTypes.SEARCH,
            interactionType: InteractionTypes.UX_ACTION,
            featureType: FeatureType
        }
    },
    ACCELERATEDREADER_VIEWCHART_CLICKED: {
        featureClick: {
            name: "AcceleratedReaderInfo"
        },
        interaction: {
            name: 'Accelerated Reader: View Chart - clicked',
            actionType: ActionTypes.INLINE_DISPLAY,
            interactionType: InteractionTypes.UX_ACTION,
            featureType: FeatureType
        }
    },
    ACCELERATEDREADER_TITLE_CLICKED: {
        featureClick: {
            name: "AcceleratedReaderSearchResults"
        },
        interaction: {
            name: 'Accelerated Reader: Title - clicked',
            actionType: ActionTypes.CATALOG_LINK,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        }
    },
    ACCELERATEDREADER_COVER_CLICKED: {
        featureClick: {
            name: "AcceleratedReaderSearchResults"
        },
        interaction: {
            name: 'Accelerated Reader: Cover - clicked',
            actionType: ActionTypes.CATALOG_LINK,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        }
    },
    ACCELERATEDREADER_FINDIT_CLICKED: {
        featureClick: {
            name: "AcceleratedReaderSearchResults"
        },
        interaction: {
            name: 'Accelerated Reader: Find It - clicked',
            actionType: ActionTypes.CATALOG_LINK,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        }
    },
    ACCELERATEDREADER_AVAILABILITY_CLICKED: {
        featureClick: {
            name: "ots"
        },
        interaction: {
            name: 'Accelerated Reader: Availability - clicked',
            actionType: ActionTypes.INLINE_DISPLAY,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        }
    },
};

export default AcceleratedReaderEventTypes;


// WEBPACK FOOTER //
// ./src/data/types/AcceleratedReaderEventTypes.js